import { Stack, styled } from '@mui/material'
import { memo } from 'react'
import { EARNS_ENABLED, isTestnet } from '../../../config'
import { ReactComponent as SvgHot } from '../../Rewards/assets/hot.svg'
import { MenuCommunity } from './Community'
import { MenuMore } from './More'
import { MenuTrade } from './Trade'
import { MenuItem } from './MenuItem'
import { MobileHead } from '../MobileHead'
import { useSetAtom } from 'jotai'
import { mobileMenuAtom } from './atoms'
import { isMobile } from 'utils/userAgent'

export const MenuWrap = styled(Stack)`
  flex-direction: row;
  align-items: center;
  height: 100%;
  padding: 0 12px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    justify-content: flex-start;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: unset;
    padding: 0;
    border-top: 1px solid ${({ theme }) => theme.color.bgGray};
    background: ${({ theme }) => theme.color.bg};
    z-index: 100;
  }
`

export const Menu = memo(() => {
  const setMobileMenu = useSetAtom(mobileMenuAtom)

  return (
    <MenuWrap>
      <MobileHead onClose={() => setMobileMenu(false)} />
      {/* <MenuItem to={'/og'}>
        $OG Rewards
        <SvgHot />
      </MenuItem> */}
      {/* <MenuTrade />
      {isMobile ? null : (
        <MenuItem to={'/portfolio/assets'}>Portfolio</MenuItem>
      )}
      {EARNS_ENABLED && (
        <MenuItem to={'/rewards/trade'}>
          <Stack direction={'row'} alignItems={'center'}>
            Rewards
            <SvgHot />
          </Stack>
        </MenuItem>
      )}
      <MenuCommunity />
      <MenuMore /> */}
    </MenuWrap>
  )
})
